import React from "react";
import { Div, Text2, Text3 } from "components/Base";
import { noop } from "utils/General";

const IMG_STYLES = {
  width: "40px",
  height: "40px",
  borderRadius: "8px",
  objectFit: "cover"
};

const WikiPageThumbnail = ({
  image = undefined,
  title = "",
  text = "",
  setActiveWikiPage = noop,
  id = null
}) => (
  <Div
    onClick={() => setActiveWikiPage(id)}
    width={1}
    p={3}
    display="row.flex-start.flex-start"
    bc="#E7E6EA"
    b={1}
    style={{ borderRadius: "8px" }}
  >
    {!!image && (
      <img alt="Wiki Page Thumbnail" style={IMG_STYLES} src={image} />
    )}
    <Div ml={image ? 4 : 0} display="column.space-between.flex-start">
      <Text3 bold color="#494949">
        {title}
      </Text3>
      <Text2 color="#666666">{text}</Text2>
    </Div>
  </Div>
);

export default WikiPageThumbnail;
